module.exports = __webpack_public_path__ + "img/65-d44d2b.png";